// Toolbar plugins were replaced with the new API in 5.40.0.
// Remove it safely after 5.40.0 (needs project upgrade).
export const dummy = {
    type: "dummy"
};
